// The home page's state while the visitor looks at an event (or any other
// page), so the browser's Back button returns to the same filters, results and
// scroll position instead of a fresh list.
//
// Keyed by the history entry (React Router's location.key): Back restores the
// list exactly as that entry left it, while arriving through a new link or the
// logo gets a new key and starts fresh. In memory only - a reload starts fresh,
// and nothing about the visitor is written to storage.

const MAX_SNAPSHOTS = 10;
const snapshots = new Map();

export function saveHomeSnapshot(historyKey, snapshot) {
  snapshots.delete(historyKey);
  snapshots.set(historyKey, snapshot);
  if (snapshots.size > MAX_SNAPSHOTS) {
    snapshots.delete(snapshots.keys().next().value);
  }
}

export function readHomeSnapshot(historyKey) {
  return snapshots.get(historyKey) || null;
}
